module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes,
    style: (_vm.styles)
  }, _vm._l((_vm.notices), function(notice) {
    return _c('Notice', {
      key: notice.name,
      attrs: {
        "prefix-cls": _vm.prefixCls,
        "styles": notice.styles,
        "type": notice.type,
        "content": notice.content,
        "duration": notice.duration,
        "closable": notice.closable,
        "name": notice.name,
        "transition-name": notice.transitionName,
        "on-close": notice.onClose
      }
    })
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e9552f6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview/src/components/base/notification/notification.vue
// module id = 592
// module chunks = 1